/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Not_FoundInputs */

const en_us2_group_not_found = /** @type {(inputs: Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group not found.`)
};

const pt_br2_group_not_found = /** @type {(inputs: Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turma não encontrada.`)
};

const pt_pt2_group_not_found = /** @type {(inputs: Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turma não encontrada.`)
};

/** @type {(inputs: Group_Not_FoundInputs) => LocalizedString} */
const es_419_group_not_found = en_us2_group_not_found;

/** @type {(inputs: Group_Not_FoundInputs) => LocalizedString} */
const fr_fr2_group_not_found = en_us2_group_not_found;

/** @type {(inputs: Group_Not_FoundInputs) => LocalizedString} */
const de_de2_group_not_found = en_us2_group_not_found;

/** @type {(inputs: Group_Not_FoundInputs) => LocalizedString} */
const it_it2_group_not_found = en_us2_group_not_found;

/**
* | output |
* | --- |
* | "Group not found." |
*
* @param {Group_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_not_found = /** @type {((inputs?: Group_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_not_found(inputs)
	if (locale === "es-419") return es_419_group_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_group_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_group_not_found(inputs)
	if (locale === "de-DE") return de_de2_group_not_found(inputs)
	if (locale === "it-IT") return it_it2_group_not_found(inputs)
	return en_us2_group_not_found(inputs)
});
export { group_not_found as "group.not_found" }